import { Link } from "react-router-dom";
import { BiErrorCircle } from "react-icons/bi";

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-8">
      <div className="max-w-2xl w-full text-center">
        <div className="animate-bounce mb-6">
          <BiErrorCircle className="w-20 h-20 sm:w-24 sm:h-24 mx-auto" />
        </div>

        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          Oops! Page Not Found
        </h2>

        <p className="text-base sm:text-lg text-gray-600 mb-8 max-w-md mx-auto">
          The path you seek does not exist. Let us guide you back to the divine
          journey.
        </p>

        <Link
          to="/"
          className="no-underline  text-red bg-slate-300 px-8 py-3 rounded-full font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300 inline-flex items-center gap-2"
        >
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
